<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 92 88" style="enable-background:new 0 0 92 88;" xml:space="preserve">
<style type="text/css">
	.st0{fill:#FFFFFF;}
	.st1{fill:#FFFFFF;stroke:#D9DDDF;stroke-width:2.25;}
	.st2{fill:none;stroke:#D90338;stroke-width:2.5;stroke-linecap:square;}
	.st3{fill:none;stroke:#006AC8;stroke-width:2.5;stroke-linecap:square;}
	.st4{fill:#FFFFFF;stroke:#313131;stroke-width:2.7;}
	.st5{fill:url(#SVGID_1_);}
	.st6{opacity:0.7;fill:none;stroke:#FFFFFF;stroke-width:2.4;stroke-linecap:square;enable-background:new    ;}
</style>
<path class="st0" d="M0,0h92v88H0V0z"/>
<path class="st1" d="M1.1,1.1h89.8v85.8H1.1V1.1z"/>
<path class="st2" d="M11,26.3l70,0.5"/>
<path class="st3" d="M11,59.3l70,0.5"/>
<path d="M27.9,50l9.9,9.9l-9.9,9.9L18,59.9L27.9,50z"/>
<path class="st4" d="M27.5,49.5l9.9,9.9l-9.9,9.9l-9.9-9.9C17.6,59.4,27.5,49.5,27.5,49.5z"/>
<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="61" y1="49.524" x2="61" y2="36.478" gradientTransform="matrix(1 0 0 -1 0 88)">
	<stop  offset="0" style="stop-color:#D90338"/>
	<stop  offset="1" style="stop-color:#0069C4"/>
</linearGradient>
<path class="st5" d="M45.5,17.5h31v51h-31V17.5z"/>
<path class="st6" d="M44,71L81,9"/>
</svg>
